<template>
  <div>
    <div v-if="item != undefined" id="colunaManifestoBtnDiv">
      <v-tooltip bottom>
        <v-chip
          class="colunaManifestoBtnChip"
          small
          slot="activator"
          :color="
            item.toLowerCase() == 'ciente'
              ? 'primary'
              : item.toLowerCase() == 'confirmada'
              ? '#1EA2F5'
              : 'red'
          "
          text-color="white"
          @click.stop="getNotaManifestada()"
        >{{item}}</v-chip>
        <span>Visualizar Manifestação</span>
      </v-tooltip> 
    </div>
    <span v-else ></span>

    <v-dialog 
      @keydown.esc="dialog = false"
      v-model="dialog"
      fullscreen
      :lazy="true"
    >
      <v-card>
        <v-card-title
          class="headline darkBlue text-xs-center"
          text-color="white"
          style="color: white;"
          primary-title    
        >
          Manifestação

          <v-spacer></v-spacer>

          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text id="bodyColunaManifesto">
          <iframe v-if="!showError" style="width: 100%; height: 90vh;" :src="'data:application/pdf;base64,'+encodeURIComponent(this.danfeB64)" frameborder="0"/>
          <h2 v-if="!showError" class="text-xs-center">{{text_info}}</h2>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getDocumentoManifesto } from '../../../../domain/notas/manifesto/colunaManifestoService.js';
export default {
  props: ['item', 'nota', 'empresa'],
  data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "",
      token: '',
      showError: false,
    };
  },
  mounted() {
    if(this.empresa.tknIntegracao && this.empresa.tknIntegracao.token) {
      this.token = this.empresa.tknIntegracao.token;
    }else {
      this.token = this.empresa.tknIntegracao ? this.empresa.tknIntegracao.refEmpresa: null;
    }
  },
  methods: {
    getNotaManifestada: async function() {
      this.danfeB64 = '';
      this.showError = false;
      this.activeGlobalLoader();
  
      const json = {
        chave: this.nota.item && this.nota.item.chave ? this.nota.item.chave : '',
        componente: this.nota.item && this.nota.item.nfe ? 'CTE' : 'NFE',
      }

      const response = await getDocumentoManifesto(this.empresa._id, json, this.token);
      this.desactiveGlobalLoader();
      this.dialog = true;
      if(response && response.pdf) {
        this.danfeB64 = response.pdf;
      }else {
        this.showError = true;
      }     
    },
    activeGlobalLoader: function() {
        const appDom = document.querySelector("#app");
        const icon = document.querySelector("#app main +i.c_custom-loader");
        const body = document.querySelector("body");
        const html = document.querySelector("html");
        body.classList.add("loading_global");
        html.classList.add("loading_global");

        appDom.classList.add("loading_global");
        icon.classList.add("loading_global");
      },
      desactiveGlobalLoader: function() {
        const appDom = document.querySelector("#app");
        const icon = document.querySelector("#app main +i.c_custom-loader");
        const body = document.querySelector("body");
        const html = document.querySelector("html");
        body.classList.remove("loading_global");
        html.classList.remove("loading_global");
        appDom.classList.remove("loading_global");
        icon.classList.remove("loading_global");
      },
  }
}
</script>

<style>
  .colunaManifestoBtnChip span.v-chip__content {
    cursor: pointer!important;
    font-size: 0.85rem!important;
  }
  #colunaManifestoBtnDiv {
    display: inline-block;
  }
  embed {
    width: 100%;
    height: 90vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_manifesto_btn/ColunaManifestoBtn.vue